import {
  ClickSyncMarkerComponent
} from '../mm-bim-view/plan-viewer/common/click-sync-marker/click-sync-marker.component';
import {Pin} from '@mydocma/tile-viewer/lib/pin/pin';

export const locationPin: Pin = {
  id: 47,
  anchor: {
    x: 50.450001,
    y: 45.523333,
  },
  markerOptions: {
    divIconOptions: {
      component: ClickSyncMarkerComponent,
      iconSize: [40, 40],
      iconAnchor: [20, 20],
      popupAnchor: [1, -34],
      className: 'arrow-icon',
    } as any
  }
};
